import dissocShareUrl from 'root/src/client/logic/static/actions/dissocShareUrl'

export default () => dispatch => dispatch(dissocShareUrl())
